/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Route Icon component.
 */
export const RouteIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.30424 3.63086H16.419C17.5555 3.63086 18.6455 4.08237 19.4491 4.886C20.2528 5.68964 20.7042 6.77961 20.7042 7.91612C20.7055 8.47921 20.5955 9.03698 20.3806 9.55745C20.1657 10.0779 19.8501 10.5509 19.4519 10.949C19.0538 11.3472 18.5809 11.6628 18.0604 11.8777C17.5399 12.0926 16.9821 12.2026 16.419 12.2013H11.2155H6.00248C4.86675 12.2038 3.77826 12.6561 2.97517 13.4592C2.17208 14.2623 1.71981 15.3508 1.71729 16.4865C1.71729 17.623 2.16874 18.713 2.97237 19.5166C3.776 20.3203 4.86597 20.7718 6.00248 20.7718H18.6955' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <circle cx='20.6086' cy='20.6091' r='1.6413' stroke={iconColor} strokeWidth='1.5' />
      <circle cx='3.3913' cy='3.3913' r='1.6413' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default RouteIcon;
